import React, { useEffect, useRef, useState } from "react";
import {
  TimePicker,
  Button,
  Modal,
  message,
  Flex,
  Divider,
  Typography,
} from "antd";
import dayjs from "dayjs";
import moment from "moment/moment";
import { useDispatch, useSelector } from "react-redux";

const TimeRangeSelector = ({
  openingTime,
  closingTime,
  onTimeChange,
  handleOk,
}) => {
  const format = "HH:mm";
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [tempOpeningTime, setTempOpeningTime] = useState();
  const [tempClosingTime, setTempClosingTime] = useState();
  const tempOpeningTimeRef = useRef(openingTime);
  const tempClosingTimeRef = useRef(closingTime);
  const [isTableModalVisible, setIsTableModalVisible] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    tempOpeningTimeRef.current = openingTime;
    tempClosingTimeRef.current = closingTime;
    setTempOpeningTime(tempOpeningTimeRef.current);
    setTempClosingTime(tempClosingTimeRef.current);
  }, [openingTime, closingTime]);

  const handleTimeOpenChange = (time, timeString) => {
    tempOpeningTimeRef.current = timeString;
    setTempOpeningTime(timeString);
    onTimeChange(tempOpeningTimeRef.current, tempClosingTimeRef.current);
  };
  const handleTimeCloseChange = (time, timeString) => {
    tempClosingTimeRef.current = timeString;
    setTempClosingTime(timeString);
    onTimeChange(tempOpeningTimeRef.current, tempClosingTimeRef.current);
  };

  return (
    <Flex vertical justify={"space-between"} style={{ height: "100%" }}>
      <div>
        <Typography.Title level={4}>Abertura</Typography.Title>
        <TimePicker
          defaultValue={dayjs(openingTime, format)}
          value={dayjs(openingTime, format)}
          format={format}
          onChange={handleTimeOpenChange}
          onOk={handleOk}
          minuteStep={15}
        />
      </div>
      <div>
        <Typography.Title level={4}>Encerramento</Typography.Title>
        <TimePicker
          format={format}
          defaultValue={dayjs(closingTime, format)}
          value={dayjs(closingTime, format)}
          onChange={handleTimeCloseChange}
          onOk={handleOk}
          minuteStep={15}
        />
      </div>
    </Flex>
  );
};

export default TimeRangeSelector;
